import './styles/state-message.css';

export default function EmptyState({ title, description, action }) {
    return (
        <div className="state-message state-message--empty" role="status">
            <p className="state-message__title">{title}</p>
            {description && <p className="state-message__description">{description}</p>}
            {action && <div className="state-message__action">{action}</div>}
        </div>
    );
}
